(function () {
  "use strict";

  var MONTHS_IT = [
    "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
    "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"
  ];

  function formatDateIt(d) {
    return d.getDate() + " " + MONTHS_IT[d.getMonth()] + " " + d.getFullYear();
  }


  function addMonthsSafe(date, monthsToAdd) {
    var d = new Date(date.getTime());
    var originalDay = d.getDate();
    d.setDate(1);
    d.setMonth(d.getMonth() + monthsToAdd);
    var daysInTargetMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    d.setDate(Math.min(originalDay, daysInTargetMonth));
    return d;
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function safeStorage() {
    try {
      var k = "__secq_test__";
      window.sessionStorage.setItem(k, "1");
      window.sessionStorage.removeItem(k);
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  var ICONS = {
    checkCircle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"></circle><path d="M8 12l3 3 5-6"></path></svg>',
    checkSmall: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 13l4 4L19 7"></path></svg>',
    batteryLow: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="6" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.8"></rect><path d="M21 10v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path><rect x="5.5" y="8.5" width="3" height="7" rx="1" fill="#d9534f"></rect></svg>'
  };


  function buildSteps(img) {
    return [
      {
        id: "intro-q1",
        kind: "intro-question",
        questionNumber: 1,
        progress: 10,
        headline: "SCOPRI COSA STA DAVVERO CAUSANDO LE TUE BORSE SOTTO GLI OCCHI",
        introText: "Questo test di 2 minuti analizza sintomi, abitudini e fattori di rischio per individuare la soluzione più adatta a te.",
       testimonial: "\u201CDue minuti di quiz ben spesi. Dopo due settimane mia moglie ha notato la differenza senza che le avessi detto niente.\u201D",
       testimonialAuthor: "PAOLO, 54 anni \u2014 cliente verificato",
testimonialImage: img.testimonial,
testimonialBadge: img.verifiedBadge,
        question: "QUAL \u00C8 IL TUO PROBLEMA PRINCIPALE INTORNO AGLI OCCHI?",
        options: [
          { icon: "👁️", label: "Borse gonfie sotto gli occhi" },
          { icon: "🔘", label: "Occhiaie scure" },
          { icon: "😴", label: "Sguardo stanco e spento" },
          { icon: "〰", label: "Zampe di gallina" }
        ]
      },
      {
        id: "q2",
        kind: "question",
        questionNumber: 2,
        progress: 20,
        question: "QUANTI ANNI HAI?",
        options: [
          { label: "65+" },
          { label: "55-65" },
          { label: "45-55" },
          { label: "35-45" },
          { label: "<35" }
        ]
      },
      {
        id: "q3",
        kind: "question",
        questionNumber: 3,
        progress: 27,
        question: "AL MATTINO, APPENA SVEGLIO, LE BORSE SONO PIÙ EVIDENTI?",
        options: [
          { label: "Molto più evidenti, poi migliorano durante il giorno" },
          { label: "Un po' più evidenti, poi migliorano durante il giorno" },
          { label: "No, rimangono uguali tutto il giorno" },
          { label: "Non ci ho mai fatto caso" }
        ],
        expandable: {
          summary: "Perché lo chiediamo",
          body: "Il gonfiore mattutino indica ritenzione di liquidi nella zona perioculare. Se le borse sono costanti tutto il giorno, la causa è più strutturale."
        }
      },
      {
        id: "q4",
        kind: "question",
        questionNumber: 4,
        progress: 34,
        question: "QUANTE ORE DI SONNO DORMI MEDIAMENTE PER NOTTE?",
        options: [
          { iconSvg: "batteryLow", label: "Meno di 5 ore" },
          { icon: "😴", label: "5–6 ore" },
          { icon: "😐", label: "7–8 ore" },
          { icon: "⚡", label: "Più di 8 ore" }
        ]
      },
      {
        id: "q5",
        kind: "question",
        questionNumber: 5,
        progress: 41,
        question: "DA QUANTO TEMPO HAI NOTATO LE BORSE SOTTO GLI OCCHI?",
        options: [
          { label: "Nelle ultime settimane" },
          { label: "Negli ultimi mesi" },
          { label: "Nell’ultimo anno" },
          { label: "Da più di un anno" },
          { label: "Non saprei" }
        ]
      },
      {
        id: "q6",
        kind: "question",
        questionNumber: 6,
        progress: 48,
        question: "COSA VORRESTI OTTENERE, PRIMA DI TUTTO?",
        options: [
          { icon: "💧", label: "Meno gonfiore sotto gli occhi" },
          { icon: "😌", label: "Uno sguardo riposato" },
          { icon: "☀️", label: "Occhiaie meno scure" },
          { icon: "⏳", label: "Sembrare più curato" },
          { icon: "〰", label: "Ridurre le zampe di gallina" },
          { icon: "✨", label: "Tutto quanto" }
        ]
      },
      {
        id: "social-proof",
        kind: "social-proof",
        progress: 55,
        kicker: "SerlinoLab",
        headline: "SEI NEL POSTO GIUSTO.",
        text: "Oltre 72.000 uomini hanno ridotto le borse sotto gli occhi e ritrovato uno sguardo riposato, fresco e disteso.",
        text2: "Formula 100% Made in Italy con caffeina e peptidi attivi, studiata per la pelle maschile.",
       customers: [
  { label: "Alessandro, 54 anni", before: img.customer1Before, after: img.customer1After },
  { label: "Carlo, 59 anni", before: img.customer2Before, after: img.customer2After },
  { label: "Fabrizio, 57 anni", before: img.customer3Before, after: img.customer3After },
  { label: "Gianni, 64 anni", before: img.customer4Before, after: img.customer4After }
],
        disclaimer: "foto di clienti reali, non ritoccate; i risultati variano da persona a persona*",
        ctaLabel: "CONTINUA →"
      },
      {
        id: "q7",
        kind: "question",
        questionNumber: 7,
        progress: 62,
        question: "QUANTE ORE AL GIORNO PASSI DAVANTI A SCHERMI (PC, SMARTPHONE, TV)?",
        options: [
          { label: "Meno di 4 ore" },
          { label: "4–8 ore" },
          { label: "8–12 ore" },
          { label: "Più di 12 ore" }
        ],
        expandable: {
          summary: "Perché lo chiediamo",
          body: "L'affaticamento visivo riduce la microcircolazione intorno agli occhi e peggiora sia il gonfiore sia il colore scuro delle occhiaie."
        }
      },
      {
        id: "q8",
        kind: "question",
        questionNumber: 8,
        progress: 69,
        question: "QUANTO SPESSO LA SERA BEVI ALCOLICI O MANGI CIBI SALATI (PIZZA, SALUMI, SNACK)?",
        options: [
          { label: "Spesso: 4+ sere a settimana" },
          { label: "A volte: 2–3 sere a settimana" },
          { label: "Raramente" },
          { label: "Quasi mai" }
        ]
      },
      {
        id: "analysis-loading",
        kind: "loading-circular",
        progress: 75,
        hideBack: true,
        headline: "ANALISI DELLE TUE RISPOSTE...",
        text: "Incrociamo quello che hai risposto finora per capire quali fattori pesano di più. Mancano solo due domande.",
        label: "ANALISI IN CORSO",
        durationMs: 5000
      },
      {
        id: "q9",
        kind: "question",
        questionNumber: 9,
        progress: 82,
        question: "COME VALUTI IL GONFIORE SOTTO GLI OCCHI NEL TEMPO?",
        options: [
          { label: "Peggiora" },
          { label: "Va e viene" },
          { label: "Resta uguale" },
          { label: "Non saprei" }
        ]
      },
      {
        id: "q10",
        kind: "question",
        questionNumber: 10,
        progress: 89,
        question: "ATTUALMENTE USI QUALCOSA PER IL CONTORNO OCCHI?",
        options: [
          { label: "Niente" },
          { label: "Solo acqua/sapone" },
          { label: "Ogni tanto una crema viso generica" },
          { label: "Un contorno occhi, ma non con costanza" },
          { label: "Altro" }
        ],
        expandable: {
          summary: "Perché lo chiediamo",
          body: "La pelle sotto l'occhio è 3–5 volte più sottile di quella del viso: le creme generiche contengono lipidi pesanti che non riescono a penetrare, drenare i liquidi e riparare i microvasi che causano le perdite."
        }
      },
      {
        id: "profile-loading",
        kind: "loading-steps",
        progress: 93,
        hideBack: true,
        headline: "STIAMO COSTRUENDO IL TUO PROFILO...",
        text: "Ancora qualche secondo. Stiamo analizzando le tue risposte.",
        steps: [
          "Analisi delle tue risposte",
          "Incrocio con le tue abitudini",
          "Calibrazione del profilo",
          "Personalizzazione del risultato"
        ],
        finalLabel: "IL RIEPILOGO DELLA TUA ROUTINE È QUASI PRONTO",
        durationMs: 4500,
        isFinal: false
      },
      {
        id: "verdict",
        kind: "verdict",
        progress: 96,
        hideBack: true,
        kicker: "La tua valutazione:",
        resultLabel: "La tua valutazione:",
        result: "PERDITA MICROVASCOLARE SEVERA",
        paragraphs: [
          "Nel tuo profilo i microvasi del contorno occhi lasciano filtrare liquidi ogni giorno, e la pelle sopra si gonfia e peggiora nel tempo.",
          "È il motivo per cui al mattino il viso sembra appesantito e lo sguardo stanco anche quando hai dormito otto ore.",
          "È anche la causa che risponde meglio ai trattamenti."
        ],
        severityLeft: "Lieve",
        severityRight: "Severo",
        severityPercent: 88,
        cards: [
          { label: "Andamento", value: "PROGRESSIVO" },
          { label: "Fattore principale", value: "RISTAGNO DI LIQUIDI" },
          { label: "Tendenza alla cronicizzazione", value: "ALTA" },
          { label: "Quadro complessivo", value: "SEVERO" }
        ],
        ctaLabel: "MOSTRAMI COSA POSSO FARE →"
      },
      {
        id: "projection",
        kind: "projection",
        progress: 98,
        headline: "L’ULTIMA COSA CHE PROVERAI PER LE TUE BORSE",
        textTemplate: "In base alle tue risposte, ci aspettiamo che tu veda ridursi visibilmente il gonfiore e i segni di stanchezza sotto gli occhi entro il [DYNAMIC DATE].",
        cardLabels: ["STATO OGGI", "STIMA SUL TUO PROFILO", "ENTRO IL"],
        cardValues: ["PERDITA MICROVASCOLARE SEVERA", "-45% di gonfiore"],
        ctaLabel: "VOGLIO IL MIO PRODOTTO →"
      },
      {
        id: "offer",
        kind: "offer",
        progress: 99,
        headline: "RITROVA IL TUO SGUARDO RIPOSATO E DISTESO CON IL CONTORNO OCCHI SERLINOLAB",
        paragraphs: [
          "Rientri nei criteri: caffeina per l’effetto sgonfiante, peptidi attivi e acido ialuronico per riparare i microvasi danneggiati e distendere la zona del contorno occhi.",
          "Applicatore in metallo freddo: trenta secondi, mattina e sera, con costanza.",
          "Provalo 60 giorni. Se non vedi la differenza, ti rimborsiamo tutto. Senza domande."
        ],
        offerLabel: "LA TUA OFFERTA",
        productImage: img.product,
        productPlaceholder: "Aggiungi il packshot nel Theme Editor",
        ctaLabel: "RISCATTA IL MIO SCONTO →"
      },
      {
        id: "discount-loading",
        kind: "loading-steps",
        progress: 100,
        hideBack: true,
        headline: "STIAMO APPLICANDO IL TUO SCONTO...",
        text: "Tra un attimo vedrai la tua offerta personalizzata...",
        steps: [
          "Verifica del tuo profilo",
          "Riserva del prodotto in corso",
          "Attivazione della garanzia 60 giorni",
          "Caricamento dell’offerta"
        ],
        finalLabel: "NON RICARICARE LA PAGINA: STIAMO APPLICANDO IL TUO SCONTO",
        durationMs: 4000,
        isFinal: true
      }
    ];
  }


  function initQuiz(root) {
    if (root.getAttribute("data-secq-initialized") === "true") return;
    root.setAttribute("data-secq-initialized", "true");

    var configEl = root.querySelector("[data-secq-config]");
    var cfg = {};
    try { cfg = JSON.parse(configEl ? configEl.textContent : "{}"); } catch (e) { cfg = {}; }
    cfg.images = cfg.images || {};

    var sectionId = cfg.sectionId || root.getAttribute("data-secq-section-id") || "default";
    var STEPS = buildSteps(cfg.images);

    var stage = root.querySelector("[data-secq-stage]");
    var progressTrack = root.querySelector("[data-secq-progress-track]");
    var progressFill = root.querySelector("[data-secq-progress-fill]");
    var backBtn = root.querySelector("[data-secq-back]");
    var liveRegion = root.querySelector("[data-secq-live-region]");

    var storage = safeStorage();
    var storageKey = "secq_eye_cream_answers";

    var state = { currentIndex: 0, answers: {} };

    if (storage) {
      try {
        var saved = JSON.parse(storage.getItem(storageKey) || "null");
        if (saved && typeof saved === "object" && saved.answers) {
          state.answers = saved.answers;
          if (typeof saved.currentIndex === "number") state.currentIndex = saved.currentIndex;
        }
      } catch (e) { /* corrupt storage — start fresh */ }
    }
    if (state.currentIndex < 0 || state.currentIndex >= STEPS.length) state.currentIndex = 0;

    var trackingStorageKey = "secq_eye_cream_tracking";
    var trackingState = { started: false, completed: false };
    var sessionId = "";
    var utmParams = {};

    function makeSessionId() {
      return "secq-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
    }

    if (storage) {
      try {
        var savedTracking = JSON.parse(storage.getItem(trackingStorageKey) || "null");
        if (savedTracking && typeof savedTracking === "object") {
          sessionId = savedTracking.sessionId || "";
          trackingState.started = Boolean(savedTracking.started);
          trackingState.completed = Boolean(savedTracking.completed);
          utmParams = savedTracking.utmParams || {};
        }
      } catch (e) { /* start a new tracking session */ }
    }
    if (!sessionId) sessionId = makeSessionId();

    try {
      var searchParams = new URLSearchParams(window.location.search);
      ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach(function (key) {
        var value = searchParams.get(key);
        if (value) utmParams[key] = value;
      });
    } catch (e) { /* URLSearchParams unavailable */ }

    function persistTracking() {
      if (!storage) return;
      try {
        storage.setItem(trackingStorageKey, JSON.stringify({
          sessionId: sessionId,
          started: trackingState.started,
          completed: trackingState.completed,
          utmParams: utmParams
        }));
      } catch (e) { /* ignore */ }
    }
    persistTracking();

    function slugifyTrackingValue(value) {
      return String(value || "")
        .toLowerCase()
        .normalize ? String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") :
        String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    }

    function trackingPayload(step, extra) {
      var payload = {
        quiz_name: cfg.quizName || "eye-cream-quiz-it",
        quiz_version: cfg.quizVersion || "v1",
        session_id: sessionId,
        variant_id: cfg.variantId || cfg.quizVersion || "v1",
        current_url: window.location.href,
        step_id: step ? step.id : "",
        step_number: step ? state.currentIndex + 1 : 0,
        total_steps: STEPS.length,
        answer_id: "",
        result_id: ""
      };
      Object.keys(utmParams).forEach(function (key) { payload[key] = utmParams[key]; });
      Object.keys(extra || {}).forEach(function (key) { payload[key] = extra[key]; });
      return payload;
    }

    function trackEvent(eventName, step, extra) {
      window.dataLayer = window.dataLayer || [];
      var payload = trackingPayload(step, extra);
      payload.event = eventName;
      window.dataLayer.push(payload);
    }

    
    var pendingTimers = [];
    var activeRaf = null;
    function scheduleTimer(fn, ms) {
        var id = window.setTimeout(fn, ms);
      pendingTimers.push(id);
      return id;
    }
    function clearAllTimers() {
      pendingTimers.forEach(function (id) { window.clearTimeout(id); });
      pendingTimers = [];
      if (activeRaf !== null) { window.cancelAnimationFrame(activeRaf); activeRaf = null; }
}

    var isTransitioning = false;
    var reduceMotion = false;
    try { reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
    catch (e) { reduceMotion = false; }

    function persist() {
      if (!storage) return;
      try {
        storage.setItem(storageKey, JSON.stringify({
          answers: state.answers,
          currentIndex: state.currentIndex,
          updatedAt: Date.now()
        }));
      } catch (e) { /* ignore */ }
    }

    function currentStep() { return STEPS[state.currentIndex]; }
    function findIndexById(id) {
 for (var i = 0; i < STEPS.length; i++) if (STEPS[i].id === id) return i;
      return -1;
    }
    function getNextIndex() {
      return state.currentIndex + 1 < STEPS.length ? state.currentIndex + 1 : -1;
    }

    function updateProgress(step) {
      var pct = typeof step.progress === "number"
        ? step.progress
        : Math.round(((state.currentIndex + 1) / STEPS.length) * 100);
      progressFill.style.width = pct + "%";
      progressTrack.setAttribute("aria-valuenow", String(pct));
    }

    function announce(text) { if (liveRegion) liveRegion.textContent = text || ""; }

 

    function renderOptionsList(step, options, onSelect) {
      var list = document.createElement("div");
      list.className = "secq-options";
      list.setAttribute("role", "radiogroup");
      list.setAttribute("aria-label", (step.question || step.headline || "").replace(/\s+/g, " "));

      var savedValue = state.answers[step.id];

      options.forEach(function (opt, i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "secq-option";
        btn.id = "secq-" + sectionId + "-" + step.id + "-opt" + i;
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", savedValue === opt.label ? "true" : "false");
        btn.setAttribute("aria-label", opt.label);
        btn.setAttribute("data-secq-option", "");

        var iconHtml = opt.iconSvg && ICONS[opt.iconSvg]
          ? '<span class="secq-option-icon" aria-hidden="true">' + ICONS[opt.iconSvg] + "</span>"
          : opt.icon
            ? '<span class="secq-option-icon" aria-hidden="true">' + escapeHtml(opt.icon) + "</span>"
            : "";
        btn.innerHTML = iconHtml + '<span class="secq-option-title">' + escapeHtml(opt.label) + "</span>";

        if (savedValue === opt.label) btn.classList.add("secq-option--selected");

        btn.addEventListener("click", function () {
          if (isTransitioning || btn.disabled) return;

          if (!trackingState.started) {
            trackingState.started = true;
            persistTracking();
            trackEvent("native_quiz_start", step);
          }

          trackEvent("native_quiz_answer", step, {
            answer_id: step.id + "_" + slugifyTrackingValue(opt.label)
          });

          Array.prototype.forEach.call(list.querySelectorAll("[data-secq-option]"), function (b) {
            b.disabled = true;
            if (b !== btn) {
              b.classList.remove("secq-option--selected");
              b.setAttribute("aria-checked", "false");
            }
          });
          btn.classList.add("secq-option--selected");
          btn.setAttribute("aria-checked", "true");

          state.answers[step.id] = opt.label;
          persist();

          isTransitioning = true;
          clearAllTimers();
          scheduleTimer(function () {
            isTransitioning = false;
            onSelect(opt);
          }, 220);
        });

        list.appendChild(btn);
      });

      return list;
    }

    function renderExpandable(summaryText, bodyText) {
      var details = document.createElement("details");
      details.className = "secq-details";
      var summary = document.createElement("summary");
      summary.className = "secq-details-summary";
      summary.textContent = summaryText;
      var p = document.createElement("p");
      p.className = "secq-details-body";
      p.textContent = bodyText;
      details.appendChild(summary);
      details.appendChild(p);
      return details;
    }

    function renderCta(label, onClick) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "secq-cta";
      btn.setAttribute("data-secq-cta", "");
      btn.textContent = label;
      btn.addEventListener("click", function () {
        if (isTransitioning || btn.disabled) return;
        btn.disabled = true;
        onClick();
      });
      return btn;
    }

    function appendParagraphs(wrap, paragraphs) {
      paragraphs.forEach(function (t) {
        var p = document.createElement("p");
        p.className = "secq-body-copy";
        p.textContent = t;
        wrap.appendChild(p);
      });
    }


    function renderIntroQuestion(wrap, step) {
      if (step.kicker) {
        var kicker = document.createElement("p");
        kicker.className = "secq-kicker";
        kicker.textContent = step.kicker;
        wrap.appendChild(kicker);
      }

      var h1 = document.createElement("h1");
      h1.className = "secq-headline";
      h1.textContent = step.headline;
      wrap.appendChild(h1);

      var introRow = document.createElement("p");
      introRow.className = "secq-intro-check";
      introRow.innerHTML =
        '<span class="secq-intro-check-icon" aria-hidden="true">' + ICONS.checkSmall + "</span>" +
        "<span>" + escapeHtml(step.introText) + "</span>";
      wrap.appendChild(introRow);

      var testimonialCard = document.createElement("div");
      testimonialCard.className = "secq-testimonial-card";

      if (step.testimonialImage) {
        var testimonialImage = document.createElement("img");
        testimonialImage.className = "secq-testimonial-image";
        testimonialImage.src = step.testimonialImage;
        testimonialImage.alt = "Paolo, cliente verificato SerlinoLab";
        testimonialImage.loading = "lazy";
        testimonialCard.appendChild(testimonialImage);
      }

      var testimonialContent = document.createElement("div");
      testimonialContent.className = "secq-testimonial-content";

      var testimonial = document.createElement("blockquote");
      testimonial.className = "secq-testimonial";
      testimonial.textContent = step.testimonial;
      testimonialContent.appendChild(testimonial);

      var authorRow = document.createElement("div");
      authorRow.className = "secq-testimonial-author-row";

      var author = document.createElement("p");
      author.className = "secq-testimonial-author";
      author.textContent = step.testimonialAuthor;
      authorRow.appendChild(author);

      if (step.testimonialBadge) {
        var verifiedBadge = document.createElement("img");
        verifiedBadge.className = "secq-testimonial-badge";
        verifiedBadge.src = step.testimonialBadge;
        verifiedBadge.alt = "Cliente verificato";
        verifiedBadge.loading = "lazy";
        authorRow.appendChild(verifiedBadge);
      }

      testimonialContent.appendChild(authorRow);
      testimonialCard.appendChild(testimonialContent);
      wrap.appendChild(testimonialCard);

      var q = document.createElement("h2");
      q.className = "secq-title";
      q.textContent = step.question;
      wrap.appendChild(q);

      wrap.appendChild(renderOptionsList(step, step.options, function () { goNext(); }));
    }

    function renderQuestionStep(wrap, step) {
      var counter = document.createElement("p");
      counter.className = "secq-question-counter";
      counter.textContent = "DOMANDA " + step.questionNumber + " DI 10";
      wrap.appendChild(counter);

      var q = document.createElement("h2");
      q.className = "secq-title";
      q.textContent = step.question;
      wrap.appendChild(q);

      wrap.appendChild(renderOptionsList(step, step.options, function () { goNext(); }));

      if (step.expandable) {
        wrap.appendChild(renderExpandable(step.expandable.summary, step.expandable.body));
      }
    }

    function renderSocialProof(wrap, step) {
      var kicker = document.createElement("p");
      kicker.className = "secq-kicker";
      kicker.textContent = step.kicker;
      wrap.appendChild(kicker);

      var h = document.createElement("h2");
      h.className = "secq-title";
      h.textContent = step.headline;
      wrap.appendChild(h);

      var socialCopyOne = document.createElement("p");
      socialCopyOne.className = "secq-body-copy";
      socialCopyOne.innerHTML = "Oltre 72.000 uomini hanno <strong>ridotto le borse sotto gli occhi</strong> e ritrovato uno sguardo riposato, fresco e disteso.";
      wrap.appendChild(socialCopyOne);

      var socialCopyTwo = document.createElement("p");
      socialCopyTwo.className = "secq-body-copy";
      socialCopyTwo.innerHTML = "Formula 100% Made in Italy con caffeina e peptidi attivi, studiata per la <strong>pelle maschile</strong>.";
      wrap.appendChild(socialCopyTwo);

      var slider = document.createElement("div");
      slider.className = "secq-social-slider";
      slider.setAttribute("role", "region");
      slider.setAttribute("aria-label", "Risultati dei clienti SerlinoLab");

      var viewport = document.createElement("div");
      viewport.className = "secq-slider-viewport";

      var card = document.createElement("div");
      card.className = "secq-social-card";
      viewport.appendChild(card);

      var dots = document.createElement("div");
      dots.className = "secq-slider-dots";

      var currentSlide = 0;
      function renderSlide(index) {
        currentSlide = (index + step.customers.length) % step.customers.length;
        var customer = step.customers[currentSlide];
        card.innerHTML = "";

        var comparison = document.createElement("div");
        comparison.className = "secq-social-comparison";

        [
          { key: "before", label: "prima di" },
          { key: "after", label: "dopo" }
        ].forEach(function (side) {
          var pane = document.createElement("div");
          pane.className = "secq-social-pane secq-social-pane--" + side.key;

          var sideLabel = document.createElement("p");
          sideLabel.className = "secq-social-side-label";
          sideLabel.setAttribute("aria-label", side.label + " SerlinoLab");
          sideLabel.appendChild(document.createTextNode(side.label + " "));

          if (cfg.images.socialLabelLogo) {
            var labelLogo = document.createElement("img");
            labelLogo.className = "secq-social-label-logo";
           labelLogo.src = cfg.images.socialLabelLogo;
            labelLogo.alt = "SerlinoLab";
            sideLabel.appendChild(labelLogo);
          } else {
            sideLabel.appendChild(document.createTextNode("SerlinoLab"));
          }
          pane.appendChild(sideLabel);

          if (customer[side.key]) {
            var customerImage = document.createElement("img");
            customerImage.className = "secq-social-image";
            customerImage.src = customer[side.key];
            customerImage.alt = customer.label + " — " + side.label;
            customerImage.loading = "lazy";
            pane.appendChild(customerImage);
          } else {
            var placeholder = document.createElement("div");
            placeholder.className = "secq-social-placeholder";
            placeholder.textContent = "Aggiungi foto";
            pane.appendChild(placeholder);
          }

          comparison.appendChild(pane);
        });
        card.appendChild(comparison);

        var name = document.createElement("p");
        name.className = "secq-social-name";
        name.textContent = customer.label;
        card.appendChild(name);

        Array.prototype.forEach.call(dots.children, function (dot, dotIndex) {
          var active = dotIndex === currentSlide;
          dot.classList.toggle("secq-slider-dot--active", active);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });
      }

      step.customers.forEach(function (customer, index) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "secq-slider-dot";
        dot.setAttribute("aria-label", "Mostra " + customer.label);
        dot.addEventListener("click", function () { renderSlide(index); });
        dots.appendChild(dot);
      });

      var touchStartX = null;
      viewport.addEventListener("touchstart", function (event) {
        touchStartX = event.touches[0].clientX;
      }, { passive: true });
      viewport.addEventListener("touchend", function (event) {
        if (touchStartX === null) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) > 45) renderSlide(currentSlide + (distance < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });

      slider.appendChild(viewport);
      slider.appendChild(dots);

      wrap.appendChild(renderCta(step.ctaLabel, function () { goNext(); }));
      wrap.appendChild(slider);
      renderSlide(0);

      function autoplay() {
        scheduleTimer(function () {
          if (!document.hidden) renderSlide(currentSlide + 1);
          autoplay();
        }, 4000);
      }
      autoplay();

      var disclaimer = document.createElement("p");
      disclaimer.className = "secq-disclaimer";
      disclaimer.textContent = step.disclaimer;
      wrap.appendChild(disclaimer);

    }

    function renderLoadingCircular(wrap, step) {
      var h = document.createElement("h2");
      h.className = "secq-title";
      h.textContent = step.headline;
      wrap.appendChild(h);

      var p = document.createElement("p");
      p.className = "secq-body-copy";
      p.textContent = step.text;
      wrap.appendChild(p);

      var circleWrap = document.createElement("div");
      circleWrap.className = "secq-circle-wrap";
      circleWrap.innerHTML =
        '<svg class="secq-circle-svg" viewBox="0 0 120 120" aria-hidden="true">' +
          '<circle class="secq-circle-track" cx="60" cy="60" r="52"></circle>' +
          '<circle class="secq-circle-progress" data-secq-circle-progress cx="60" cy="60" r="52"></circle>' +
        "</svg>" +
        '<span class="secq-circle-percentage" data-secq-circle-percentage>0%</span>';
      wrap.appendChild(circleWrap);

      var label = document.createElement("p");
      label.className = "secq-loading-label";
      label.textContent = step.label;
      wrap.appendChild(label);

      var circleProgress = circleWrap.querySelector("[data-secq-circle-progress]");
      var circlePercentage = circleWrap.querySelector("[data-secq-circle-percentage]");
      var circumference = 2 * Math.PI * 52;
      circleProgress.style.strokeDasharray = circumference.toFixed(2);
      circleProgress.style.strokeDashoffset = circumference.toFixed(2);

      var durationMs = step.durationMs || 5000;
      var startTime = null;

      function tick(ts) {
        if (startTime === null) startTime = ts;
        var elapsed = ts - startTime;
        var pct = Math.min(100, Math.round((elapsed / durationMs) * 100));
        circleProgress.style.strokeDashoffset = (circumference * (1 - pct / 100)).toFixed(2);
        circlePercentage.textContent = pct + "%";
        if (pct < 100) {
          activeRaf = window.requestAnimationFrame(tick);
        } else {
          activeRaf = null;
        }
      }

      if (reduceMotion) {
        circlePercentage.textContent = "100%";
        circleProgress.style.strokeDashoffset = "0";
      } else {
        activeRaf = window.requestAnimationFrame(tick);
      }

      scheduleTimer(function () { goNext(); }, durationMs);
    }

    function renderLoadingSteps(wrap, step) {
      var h = document.createElement("h2");
      h.className = "secq-title";
      h.textContent = step.headline;
      wrap.appendChild(h);
       var p = document.createElement("p");
      p.className = "secq-body-copy";
      p.textContent = step.text;
      wrap.appendChild(p);

      var spinner = document.createElement("div");
      spinner.className = "secq-spinner";
      spinner.setAttribute("aria-hidden", "true");
      wrap.appendChild(spinner);

      var list = document.createElement("ul");
      list.className = "secq-loading-steps";
      step.steps.forEach(function (label) {
        var li = document.createElement("li");
        li.className = "secq-loading-step";
        li.innerHTML =
   '<span class="secq-loading-step-icon" aria-hidden="true">' + ICONS.checkSmall + "</span>" +
          "<span>" + escapeHtml(label) + "</span>";
        list.appendChild(li);
      });
      wrap.appendChild(list);

      var finalLabel = document.createElement("p");
      finalLabel.className = "secq-loading-final";
      finalLabel.textContent = step.finalLabel;
      finalLabel.hidden = true;
      wrap.appendChild(finalLabel);

      var items = list.querySelectorAll(".secq-loading-step");
      var totalDuration = step.durationMs || 4500;
      var stepDelay = totalDuration / (items.length + 1);

      items.forEach(function (li, i) {
        scheduleTimer(function () {
          li.classList.add("secq-loading-step--done");
        }, stepDelay * (i + 1));
      });

      var finalLabelDelay = Math.max(totalDuration - 400, stepDelay * items.length);
      scheduleTimer(function () {
        finalLabel.hidden = false;
        announce(step.finalLabel);
      }, finalLabelDelay);

      scheduleTimer(function () {
        if (step.isFinal) {
          persist();
          window.location.href = cfg.redirectUrl || "https://serlinolab.it/pages/contorno-occhi-serlinolab-promo-v1";
        } else {
          goNext();
        }
      }, totalDuration);
    }

    function renderVerdict(wrap, step) {
      wrap.classList.add("secq-verdict");

      var kicker = document.createElement("p");
      kicker.className = "secq-kicker";
      kicker.textContent = step.kicker;
      wrap.appendChild(kicker);

      var assessment = document.createElement("div");
      assessment.className = "secq-assessment-card";

      var assessmentHead = document.createElement("div");
      assessmentHead.className = "secq-assessment-head";
      assessmentHead.innerHTML =
        '<span class="secq-assessment-icon" aria-hidden="true">!</span>' +
        '<div class="secq-assessment-heading"></div>';

      var resultLabel = document.createElement("p");
      resultLabel.className = "secq-result-label";
      resultLabel.textContent = step.resultLabel;

      var result = document.createElement("h2");
      result.className = "secq-title secq-result-title";
      result.textContent = step.result;
      assessmentHead.querySelector(".secq-assessment-heading").appendChild(resultLabel);
      assessmentHead.querySelector(".secq-assessment-heading").appendChild(result);
      assessment.appendChild(assessmentHead);

      var explanation = document.createElement("div");
      explanation.className = "secq-assessment-copy";
      appendParagraphs(explanation, step.paragraphs);
      assessment.appendChild(explanation);

      var meter = document.createElement("div");
      meter.className = "secq-severity";
      meter.innerHTML =
        '<p class="secq-severity-title">Livello di perdita microvascolare</p>' +
        '<div class="secq-severity-track"><span class="secq-severity-marker" style="left:' + step.severityPercent + '%"></span></div>' +
        '<div class="secq-severity-labels"><span>' + escapeHtml(step.severityLeft) + "</span><span>" + escapeHtml(step.severityRight) + "</span></div>";
      assessment.appendChild(meter);
      wrap.appendChild(assessment);

      var grid = document.createElement("div");
      grid.className = "secq-summary-grid";
      var icons = ["↗", "◆", "◷", "!"];
      step.cards.forEach(function (c, index) {
        var card = document.createElement("div");
        card.className = "secq-summary-card";
        card.innerHTML =
          '<span class="secq-summary-icon" aria-hidden="true">' + icons[index] + "</span>" +
          '<span class="secq-summary-content"><span class="secq-summary-label">' + escapeHtml(c.label) + "</span>" +
          '<span class="secq-summary-value">' + escapeHtml(c.value) + "</span></span>";
        grid.appendChild(card);
      });
      wrap.appendChild(grid);

      wrap.appendChild(renderCta(step.ctaLabel, function () { goNext(); }));
    }

    function renderProjectionChart(dateText) {
      var wrapper = document.createElement("div");
      wrapper.className = "secq-chart-wrap";
      wrapper.innerHTML =
        '<p class="secq-chart-title">RIDUZIONE PREVISTA DEL GONFIORE</p>' +
        '<svg class="secq-chart-svg" viewBox="0 0 640 270" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Grafico animato che mostra la riduzione prevista del gonfiore nei prossimi tre mesi">' +
          '<defs>' +
            '<linearGradient id="secq-chart-area-gradient" x1="0" y1="0" x2="0" y2="1">' +
              '<stop offset="0%" stop-color="#f5c94a" stop-opacity="0.34"></stop>' +
              '<stop offset="100%" stop-color="#f5c94a" stop-opacity="0.02"></stop>' +
            '</linearGradient>' +
          '</defs>' +
          '<line class="secq-chart-grid" x1="88" y1="48" x2="604" y2="48"></line>' +
          '<line class="secq-chart-grid" x1="88" y1="118" x2="604" y2="118"></line>' +
          '<line class="secq-chart-grid" x1="88" y1="188" x2="604" y2="188"></line>' +
          '<text x="18" y="122" class="secq-chart-y-title" text-anchor="middle" transform="rotate(-90 18 122)">GONFIORE</text>' +
          '<text x="38" y="52" class="secq-chart-axis-label">ALTO</text>' +
          '<text x="38" y="122" class="secq-chart-axis-label">MEDIO</text>' +
          '<text x="38" y="192" class="secq-chart-axis-label">BASSO</text>' +
          '<path class="secq-chart-area" d="M105 48 C185 56 220 68 270 82 S390 125 435 144 S535 178 585 188 L585 208 L105 208 Z"></path>' +
          '<path class="secq-chart-line" pathLength="1" d="M105 48 C185 56 220 68 270 82 S390 125 435 144 S535 178 585 188"></path>' +
          '<circle class="secq-chart-dot secq-chart-dot--1" cx="105" cy="48" r="7"></circle>' +
          '<circle class="secq-chart-dot secq-chart-dot--2" cx="270" cy="82" r="7"></circle>' +
          '<circle class="secq-chart-dot secq-chart-dot--3" cx="435" cy="144" r="7"></circle>' +
          '<circle class="secq-chart-dot secq-chart-dot--4" cx="585" cy="188" r="7"></circle>' +
          '<g class="secq-chart-here"><rect x="74" y="61" width="64" height="22" rx="11"></rect><text x="106" y="76" text-anchor="middle">SEI QUI</text></g>' +
          '<text x="105" y="245" class="secq-chart-x-label" text-anchor="middle">OGGI</text>' +
          '<text x="270" y="245" class="secq-chart-x-label" text-anchor="middle">+1 mese</text>' +
          '<text x="435" y="245" class="secq-chart-x-label" text-anchor="middle">+2 mesi</text>' +
          '<text x="575" y="236" class="secq-chart-x-label" text-anchor="middle">+3 mesi<tspan x="575" dy="16" class="secq-chart-date">' + escapeHtml(dateText) + '</tspan></text>' +
        "</svg>";
      return wrapper;
    }

    function renderProjection(wrap, step) {
      wrap.classList.add("secq-projection");

      var h = document.createElement("h2");
      h.className = "secq-title";
      h.textContent = step.headline;
      wrap.appendChild(h);

      var targetDate = addMonthsSafe(new Date(), 3);
      var dateText = formatDateIt(targetDate);

      var p = document.createElement("p");
      p.className = "secq-body-copy";
      p.innerHTML = 'In base alle tue risposte, ci aspettiamo che tu veda <strong>ridursi visibilmente il gonfiore</strong> e i segni di stanchezza sotto gli occhi entro il ' + escapeHtml(dateText) + ".";
      wrap.appendChild(p);

      var projectionPanel = document.createElement("div");
      projectionPanel.className = "secq-projection-panel";

      var cardsWrap = document.createElement("div");
      cardsWrap.className = "secq-projection-cards";
      var cardsData = [
        { label: step.cardLabels[0], value: step.cardValues[0] },
        { label: step.cardLabels[1], value: step.cardValues[1] },
        { label: step.cardLabels[2], value: dateText }
      ];
      cardsData.forEach(function (c) {
        var card = document.createElement("div");
        card.className = "secq-projection-card";
        card.innerHTML =
          '<span class="secq-summary-label">' + escapeHtml(c.label) + "</span>" +
          '<span class="secq-summary-value">' + escapeHtml(c.value) + "</span>";
        cardsWrap.appendChild(card);
      });
      projectionPanel.appendChild(cardsWrap);
      projectionPanel.appendChild(renderProjectionChart(dateText));
      wrap.appendChild(projectionPanel);

      wrap.appendChild(renderCta(step.ctaLabel, function () { goNext(); }));
    }

    function renderOffer(wrap, step) {
      wrap.classList.add("secq-offer");

      var h = document.createElement("h2");
      h.className = "secq-title";
      h.textContent = step.headline;
      wrap.appendChild(h);

      var offerIntro = document.createElement("p");
      offerIntro.className = "secq-body-copy";
      offerIntro.innerHTML = "Rientri nei criteri: caffeina per l’<strong>effetto sgonfiante</strong>, peptidi attivi e acido ialuronico per <strong>riparare i microvasi danneggiati</strong> e distendere la zona del contorno occhi.";
      wrap.appendChild(offerIntro);

      appendParagraphs(wrap, step.paragraphs.slice(1));

      var offerLabel = document.createElement("p");
      offerLabel.className = "secq-offer-label";
      offerLabel.textContent = step.offerLabel;
      wrap.appendChild(offerLabel);

      var offerShowcase = document.createElement("div");
      offerShowcase.className = "secq-offer-showcase";

      var productWrap = document.createElement("div");
      productWrap.className = "secq-offer-product";
      if (step.productImage) {
        var img = document.createElement("img");
        img.className = "secq-offer-product-image";
        img.src = step.productImage;
        img.alt = "Contorno Occhi SerlinoLab";
        img.loading = "lazy";
        productWrap.appendChild(img);
      } else {
        var placeholder = document.createElement("div");
        placeholder.className = "secq-offer-placeholder";
        placeholder.textContent = step.productPlaceholder;
        productWrap.appendChild(placeholder);
      }
      offerShowcase.appendChild(productWrap);

      wrap.appendChild(offerShowcase);

      wrap.appendChild(renderCta(step.ctaLabel, function () {
        trackEvent("native_quiz_cta_click", step, {
          result_id: "perdita_microvascolare_severa",
          destination_url: cfg.redirectUrl || "https://serlinolab.it/pages/contorno-occhi-serlinolab-promo-v1"
        });
        goNext();
      }));
    }

    function renderStepMarkup(step) {
      var wrap = document.createElement("div");
      wrap.className = "secq-step";
      wrap.setAttribute("data-secq-step-id", step.id);
      wrap.setAttribute("data-secq-active", "true");
      wrap.setAttribute("role", "group");
      wrap.setAttribute("aria-roledescription", "schermata del quiz");

      switch (step.kind) {
        case "intro-question": renderIntroQuestion(wrap, step); break;
        case "question": renderQuestionStep(wrap, step); break;
        case "social-proof": renderSocialProof(wrap, step); break;
        case "loading-circular": renderLoadingCircular(wrap, step); break;
        case "loading-steps": renderLoadingSteps(wrap, step); break;
        case "verdict": renderVerdict(wrap, step); break;
        case "projection": renderProjection(wrap, step); break;
        case "offer": renderOffer(wrap, step); break;
        default: break;
      }

      return wrap;
    }



    function renderStepAtIndex(index) {
      clearAllTimers();
      state.currentIndex = index;
      persist();

      stage.innerHTML = "";
      var step = currentStep();
      stage.appendChild(renderStepMarkup(step));
      updateProgress(step);

      trackEvent("native_quiz_step_view", step, {
        result_id: step.id === "verdict" || step.id === "projection" || step.id === "offer"
          ? "perdita_microvascolare_severa"
          : ""
      });

      if (step.id === "verdict" && !trackingState.completed) {
        trackingState.completed = true;
        persistTracking();
        trackEvent("native_quiz_complete", step, {
          result_id: "perdita_microvascolare_severa"
        });
      }

      backBtn.hidden = index === 0 || Boolean(step.hideBack);

      announce(step.headline || step.question || step.result || "");
    }

    function pushHistoryEntry(stepId, index) {
      try { history.pushState({ secqStepIndex: index }, "", "#" + stepId); }
      catch (e) { /* ignore in restrictive environments */ }
    }
    function replaceHistoryEntry(stepId, index) {
      try { history.replaceState({ secqStepIndex: index }, "", "#" + stepId); }
      catch (e) { /* ignore in restrictive environments */ }
    }

    function goNext() {
      var nextIndex = getNextIndex();
      if (nextIndex === -1) return;
      pushHistoryEntry(STEPS[nextIndex].id, nextIndex);
      renderStepAtIndex(nextIndex);
    }

    function goBack() {
      if (state.currentIndex === 0) return;
      history.back();
    }

    window.addEventListener("popstate", function (e) {
      var targetIndex = null;
      if (e.state && typeof e.state.secqStepIndex === "number") {
        targetIndex = e.state.secqStepIndex;
      } else {
        var hashId = window.location.hash.replace("#", "");
        var idx = findIndexById(hashId);
        if (idx !== -1) targetIndex = idx;
      }
      if (targetIndex === null) targetIndex = 0;
      if (targetIndex === state.currentIndex) return;
      renderStepAtIndex(targetIndex);
    });

    backBtn.addEventListener("click", function () {
      if (isTransitioning) return;
      trackEvent("native_quiz_back", currentStep());
      goBack();
    });

    function boot() {
      var initialIndex = state.currentIndex || 0;
      if (initialIndex < 0 || initialIndex >= STEPS.length) initialIndex = 0;
      replaceHistoryEntry(STEPS[initialIndex].id, initialIndex);
      trackEvent("native_quiz_view", STEPS[initialIndex]);
      renderStepAtIndex(initialIndex);
    }

    boot();
  }

  function initAll() {
    var roots = document.querySelectorAll("[data-secq-root]");
    roots.forEach(function (root) { initQuiz(root); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    var root = evt.target && evt.target.querySelector ? evt.target.querySelector("[data-secq-root]") : null;
    if (root) initQuiz(root);
    else initAll();
  });
  document.addEventListener("shopify:section:reorder", initAll);
})();
